<template>
  <div class="live" id="live">
    <div class="live-item-box">
      <div class="tit">
        <img src="@/assets/images/tit-live.jpg" alt />
      </div>
      <!-- 倒计时 -->
      <!-- <span v-if="datetimeshow" class="dowe-time">
        <p>距离第一场直播开始还有: <b>{{odatetime.minutes}}</b> 分 <b>{{odatetime.seconds}}</b> 秒</p>
      </span>-->

      <!--正在直播-->
      <div class="live-hot" v-if="liveList.length != 0">
        <swiper class="swiper-container" :options="swiperOption" ref="mySwiper">
          <swiper-slide class="swiper-slide live-hot-con" v-for="(item, index) in liveList" :key="index">
            <div class="live-hot-item fix">
              <h5 class="ofw-hide">{{ item.name }}</h5>
              <dl class="fix">
                <dt>
                  <img :src="item.head" alt />
                  <a @click="toLive2(item.id)">
                    <span class="live-hot-view">点击观看</span>
                  </a>
                </dt>
                <dd>
                  <b>{{ item.teacherName }}</b>
                  <em>{{ item.position }}</em>
                  <span>
                    <div class="ofw-hide-4">{{ item.introduction }}</div>
                  </span>
                </dd>
              </dl>
            </div>
            <div class="live-hot-tit">{{ item.liveName }}</div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>

      <!--直播频道-->
      <div class="live-channel">
        <ul class="con-tab2">
          <li :class="{ active: index == currentIndex }" v-for="(item, index) in countryList" :key="index" @click="countrychange(index)">{{ item }}</li>
        </ul>
        <div class="live-channel-hid" v-if="dataList.length > 0">
          <ul>
            <li v-for="(item, index) in dataList[currentIndex].details" :key="index" @click="tabchange(index)">
              <div style="padding-bottom: 0.1rem; border-bottom: 1px solid #e5e5e5">
                <!-- 直播选项 -->
                <div class="live-top">
                  <div class="flex-1">
                    <img src="@/assets/images/live_icon_1.png" alt />
                  </div>
                  <div class="flex-2">
                    <span class="time">
                      {{
                      item.startHour +
                      ":" +
                      (item.startMinute == 0 ? "00" : item.startMinute) +
                      "-" +
                      item.endHour +
                      ":" +
                      (item.endMinute == 0 ? "00" : item.endMinute)
                      }}
                    </span>
                    <h3 class="ofw-hide-2" :class="{ red: item.status == 2 }">{{ item.name }}</h3>
                  </div>
                  <span v-if="item.status == 1" class="flex-3 btn btn-1" @click="toLive(item)">
                    <i class="status-point1"></i>马上开播
                  </span>
                  <span v-else-if="item.status == 2" class="flex-3 btn btn-2" @click="toLive(item)">
                    <i class="status-point2"></i>点击观看
                  </span>
                  <span v-else-if="item.status == 3" class="flex-3 btn btn-3">
                    <i class="status-point1"></i>已结束
                  </span>
                </div>
                <!-- 直播详情 -->
                <div v-if="index == tabIndex" class="live-item">
                  <dl class="fix">
                    <dt>
                      <img :src="item.head" v-if="item.status == 1" @click="toLive(item)" />
                      <img :src="item.head" v-if="item.status == 2" @click="toLive(item)" />
                      <img :src="item.head" v-if="item.status == 3" />
                      <span v-if="item.status == 1" class="flex-3 btn btn-1" @click="toLive(item)">马上开播</span>
                      <span v-else-if="item.status == 2" @click="toLive(item)" class="flex-3 btn btn-2">点击观看</span>
                      <span v-else-if="item.status == 3" class="flex-3 btn btn-3">直播结束</span>
                    </dt>
                    <dd>
                      <h5>{{ item.teacherName }}</h5>
                      <b>{{ item.position }}</b>
                      <p>{{ item.introduction }}</p>
                    </dd>
                  </dl>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="tc-bg1" v-if="popShow > 0">
      <div class="tc">
        <img src="@/assets/images/close.png" class="close" @click="popShow = 0" alt />
        <img src="@/assets/images/tc_tu1.jpg" class="warning" style="margin-top: 0.6rem" alt />
        <p v-if="popShow == 1">直播未开始</p>
        <p v-else>直播已结束</p>
        <div style="height: 0.2rem"></div>
        <div class="btn">
          <button class="btn2" @click="popShow = 0">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLiveDetail, getCurrentLive, baseUrl } from "@/api/home";
export default {
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    expoId: {
      type: Number,
      default: 0,
    },
  },
  name: "live",
  components: {},
  //属性器
  computed: {
    itemlist: {
      get: function () {
        if (this.dataList.length > 0) {
          let dt = this.dataList.filter(
            (item) => item.id == this.countryIndex
          )[0].details;
          dt.forEach((e) => {
            e.time =
              e.startHour +
              ":" +
              (e.startMinute == 0 ? "00" : e.startMinute) +
              "-" +
              e.endHour +
              ":" +
              (e.endMinute == 0 ? "00" : e.endMinute);
          });
          return dt;
        }
        return [];
      },
    },
    lowageitemlist: {
      get: function () {
        if (this.dataList.length > 0) {
          let dt = this.dataList[8].details;
          dt.forEach((e) => {
            e.time =
              e.startHour +
              ":" +
              (e.startMinute == 0 ? "00" : e.startMinute) +
              "-" +
              e.endHour +
              ":" +
              (e.endMinute == 0 ? "00" : e.endMinute);
          });
          return dt;
        }
        return [];
      },
    },
    examitemlist: {
      get: function () {
        if (this.dataList.length > 0) {
          let dt = this.dataList[9].details;
          dt.forEach((e) => {
            e.time =
              e.startHour +
              ":" +
              (e.startMinute == 0 ? "00" : e.startMinute) +
              "-" +
              e.endHour +
              ":" +
              (e.endMinute == 0 ? "00" : e.endMinute);
          });
          return dt;
        }
        return [];
      },
    },
    pages1: {
      get: function () {
        return Math.ceil(this.itemlist.length / 5);
      },
    },
    pages2: {
      get: function () {
        return Math.ceil(this.lowageitemlist.length / 5);
      },
    },
    pages3: {
      get: function () {
        return Math.ceil(this.examitemlist.length / 5);
      },
    },
  },
  data() {
    return {
      typeIndex: 0,
      dataList: [], // 直播列表
      itemIndex1: null, //直播索引
      itemIndex2: null, //直播索引
      itemIndex3: null, //直播索引
      liveList: [], // 正在直播列表
      liveId: "", // 跳转直播地址
      item: {},
      swiperOption: {
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        //loop: true,
      },
      liveSwiperOptions: {
        slidesPerView: 1, //一行显示4个
        //slidesPerGroup: 2, //显示2行
        // slidesPerColumnFill: "row",
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
      },
      popShow: 0,
      countryList: ["商科综合频道", "金融会计专业频道"],
      currentIndex: 0,
      tabIndex: 0,
      // countryIndex: "900",
      itemCount: 5,
      datetimeshow: false,
      begintime: "2020-11-28 9:00:00",
      endtime: "2020-11-28 10:00:00",
      odatetime: { days: 0, hours: 0, minutes: 0, seconds: 0 },
    };
  },
  methods: {
    // 获取直播列表
    async getLiveDetail() {
      let res = await getLiveDetail({
        params: {
          expoId: this.expoId,
        },
      });
      console.log(res);
      if (res.succ) {
        this.dataList = res.results;
        for (let i in this.dataList) {
          for (let j in this.dataList[i].details) {
            if (this.dataList[i].details[j].status == 2) {
              this.tabIndex = j;
              return;
            }
          }
        }
      }
    },

    // dateTimeShow() {
    //   //当前时间
    //   let date = new Date();
    //   let now = date.getTime();
    //   //开始展示倒计时时间
    //   let beginDate = new Date(this.begintime);
    //   let begin = beginDate.getTime();
    //   //结束倒计时时间
    //   let endDate = new Date(this.endtime);
    //   let end = endDate.getTime();
    //   let myVar;
    //   if (now >= begin && now < end) {
    //     this.datetimeshow = true;
    //     myVar = setInterval(this.loveTime, 1000);
    //   }
    //   if (now >= end && this.datetimeshow == true) {
    //     this.datetimeshow = false;
    //     if (myVar) {
    //       clearInterval(myVar);
    //     }
    //   }
    // },

    // loveTime() {
    //   //获取当前时间
    //   let date = new Date();
    //   let now = date.getTime();
    //   //设置截止时间
    //   let endDate = new Date(this.endtime);
    //   let end = endDate.getTime();
    //   //时间差
    //   let leftTime = end - now;
    //   //定义变量 d,h,m,s保存倒计时的时间
    //   if (leftTime >= 0) {
    //     this.odatetime.days = Math.floor(leftTime / 1000 / 60 / 60 / 24);
    //     this.odatetime.hours = Math.floor((leftTime / 1000 / 60 / 60) % 24);
    //     this.odatetime.minutes = Math.floor((leftTime / 1000 / 60) % 60);
    //     this.odatetime.seconds = Math.floor((leftTime / 1000) % 60);
    //   }
    //   if (now >= end) {
    //     this.datetimeshow = false;
    //   }
    // },

    // 获取正在直播列表
    async getCurrentLiveList() {
      const { succ, results } = await getCurrentLive({
        params: {
          expoId: this.expoId,
        },
      });
      if (succ) {
        this.liveList = results;
        console.log(results);
      }
    },

    //国家切换
    countrychange(index) {
      this.currentIndex = index;
      for (let i in this.dataList) {
        for (let j in this.dataList[i].details) {
          if (this.dataList[i].details[j].status == 2) {
            this.tabIndex = j;
          }
        }
      }
    },

    tabchange(index) {
      this.tabIndex = index;
    },

    //获取需要展示数据
    // getLiveItem(type) {
    //   let item;
    //   if (type == 1) {
    //     if (this.itemIndex1) return this.itemIndex1;
    //     let list = this.itemlist.filter((x) => x.status == 2);
    //     if (list.length > 0) {
    //       item = list.pop();
    //     } else {
    //       item = this.itemlist.filter((x) => x.status == 1)[0];
    //     }
    //   } else if (type == 2) {
    //     if (this.itemIndex2) return this.itemIndex2;
    //     let list = this.lowageitemlist.filter((x) => x.status == 2);
    //     if (list.length > 0) {
    //       item = list.pop();
    //     } else {
    //       item = this.lowageitemlist.filter((x) => x.status == 1)[0];
    //     }
    //   } else {
    //     if (this.itemIndex3) return this.itemIndex3;
    //     let list = this.examitemlist.filter((x) => x.status == 2);
    //     if (list.length > 0) {
    //       item = list.pop();
    //     } else {
    //       item = this.examitemlist.filter((x) => x.status == 1)[0];
    //     }
    //   }

    //   return item;
    // },

    //翻页定位
    // turnThePage() {
    //   var p1, p2, p3;
    //   let _self = this;

    //   this.itemlist.forEach((e, i) => {
    //     if (e == _self.getLiveItem(1)) {
    //       p1 = i;
    //     }
    //   });
    //   this.lowageitemlist.forEach((e, i) => {
    //     if (e == _self.getLiveItem(2)) {
    //       p2 = i;
    //     }
    //   });
    //   this.examitemlist.forEach((e, i) => {
    //     if (e == _self.getLiveItem(3)) {
    //       p3 = i;
    //     }
    //   });
    //   if ((p1 + 1) / 5 > 1) {
    //     let _self = this;
    //     setTimeout(() => {
    //       let swiper = _self.$refs.mySwiper1.$el.swiper;
    //       swiper.activeIndex = 1;
    //       swiper.update();
    //     });
    //   }
    //   if ((p2 + 1) / 5 > 1) {
    //     let _self = this;
    //     setTimeout(() => {
    //       let swiper = _self.$refs.mySwiper2.$el.swiper;
    //       swiper.activeIndex = 1;
    //       swiper.update();
    //     });
    //   }
    //   if ((p3 + 1) / 5 > 1) {
    //     let _self = this;
    //     setTimeout(() => {
    //       let swiper = _self.$refs.mySwiper3.$el.swiper;
    //       swiper.activeIndex = 1;
    //       swiper.update();
    //     });
    //   }
    // },

    toLive(item) {
      if (item) {
        this.item = item;
      }
      let liveId = this.item.liveId; //直播id
      let status = this.item.status; //直播状态
      let currTime = parseInt(new Date().getTime() / 1000); //当前时间
      let startTime = this.item.startTime - 900; //提前30分钟的开始时间
      let endTime = Number(this.item.endTime); //结束时间

      if (!this.isLogin) {
        this.$emit("showLogin", "live");
        return;
      }

      if ((startTime < currTime && endTime > currTime) || status == 2) {
        //console.log("已经到了直播时间的提前半小时,可以进直播");
        window.location.href = `${baseUrl}/live/watch?id=${liveId}`;
      } else {
        this.popShow = 1;
      }
    },

    // 正在直播
    toLive2(liveId) {
      if (liveId) {
        this.liveId = liveId;
      }
      if (!this.isLogin) {
        this.$emit("showLogin", "currLive");
        return;
      }
      window.location.href = `${baseUrl}/live/watch?id=${this.liveId}`;
    },
  },
  async created() {},
  watch: {
    expoId(newVal, val) {
      if (newVal) {
        this.getLiveDetail();
        this.getCurrentLiveList();
        // this.dateTimeShow();
      }
    },
  },
};
</script>
<style lang="less">
.live {
  .live-item-box {
    background: #fff;
    padding-bottom: 0.4rem;
    // .dowe-time {
    //   background: url("~@/assets/images/down_time.png") no-repeat;
    //   background-size: 100% 100%;
    //   height: 0.5rem;
    //   display: block;
    //   width: 4.88rem;
    //   margin: 0 auto;
    //   padding-left: 0.9rem;
    //   p {
    //     font-size: 0.22rem;
    //     font-family: Source Han Sans CN;
    //     font-weight: 400;
    //     color: #505050;
    //     b {
    //       font-size: 0.3rem;
    //       font-family: Source Han Sans CN;
    //       font-weight: 500;
    //       color: #f12d31;
    //     }
    //   }
    // }
    // 正在直播
    .live-hot {
      margin: 0.3rem;
      .swiper-container {
        border-radius: 0.22rem;
        margin: 0 auto 0.2rem;
        padding-bottom: 0.6rem;
        .live-hot-con {
          position: relative;
          .live-hot-item {
            border-radius: 0.14rem;
            border: 0.05rem solid #379af4;
            margin-top: 0.2rem;
            padding: 0 0.2rem 0.2rem;
            h5 {
              padding-bottom: 0.2rem;
              padding-top: 0.5rem;
              font-size: 0.28rem;
              font-family: FZLanTingYuanS-DB1-GB;
              font-weight: 900;
              color: #333c3f;
            }
            dl {
              dt {
                width: 1.73rem;
                height: 2.4rem;
                float: left;
                // background: url(~@/assets/images/live_head_bg.png) no-repeat;
                // background-size: 100% 100%;
                position: relative;
                margin-right: 0.25rem;
                display: flex;
                align-items: center;
                a {
                  display: block;
                  width: 1.72rem;
                  height: 2.4rem;
                  position: absolute;
                  top: 0;
                  left: 0;
                  .live-play {
                    width: 0.77rem;
                    height: 0.77rem;
                    background: rgba(255, 255, 255, 0.33);
                    border: 0.02px solid rgba(255, 255, 255, 1);
                    border-radius: 50%;
                    margin-top: 0.8rem;
                  }
                }
                img {
                  width: 1.48rem;
                  height: 1.48rem;
                  display: block;
                  margin: 0 auto 0.12rem;
                  background-color: #d8d8e0;
                  border-radius: 50%;
                }
                span {
                  width: 1.72rem;
                  height: 0.39rem;
                  display: block;
                  line-height: 0.39rem;
                  position: absolute;
                  top: 1.7rem;
                  left: 0;
                  background-color: #f15d57;
                  text-align: center;
                  font-size: 0.22rem;
                  font-family: Source Han Sans CN;
                  font-weight: 500;
                  color: #fff;
                  border-radius: 0.25rem 0.2rem 0.2rem 0;
                }
              }

              dd {
                width: 4.1rem;
                float: left;

                b {
                  display: inline-block;
                  padding-bottom: 0.05rem;
                  padding-top: 0.2rem;
                  font-size: 0.28rem;
                  border-bottom: 0.05rem solid #379af4;
                  font-family: FZLanTingYuanS-DB1-GB;
                  font-weight: 400;
                  color: #333c3f;
                }
                em {
                  display: block;
                  line-height: 1.4;
                  font-style: normal;
                  font-size: 0.2rem;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  padding-top: 0.1rem;
                }
                span {
                  display: block;
                  font-size: 0.22rem;
                  color: #666666;
                }
              }
            }
            p {
              display: -webkit-box;
              padding-top: 0.15rem;
              background: #fff;
              border-radius: 0.14rem;
              padding: 0.21rem 0.26rem;
              font-size: 0.22rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #5e5e5e;
              line-height: 0.26rem;
              box-shadow: 2px 2px 0px 0px #eceef0;
            }
          }
          .live-hot-tit {
            height: 0.46rem;
            line-height: 0.46rem;
            border-radius: 1rem;
            border: 0.03rem solid #fcca1b;
            position: absolute;
            left: 0;
            top: 0rem;
            background: #fff url(~@/assets/images/live_icon5.png) no-repeat;
            background-size: 1.6rem 105%;
            padding-left: 1.7rem;
            padding-right: 0.2rem;
            font-size: 0.24rem;
            font-weight: 900;
          }
        }
      }

      .swiper-pagination {
        bottom: 0;
      }
    }

    // 直播列表
    .live-channel {
      border-radius: 0.1rem;
      margin: 0.19rem 0.29rem 0;
      position: relative;
      background-color: #fff;
      box-shadow: 0rem 0rem 0.5rem 0.05rem #eee;
      // tab切换
      .con-tab2 {
        border-radius: 0.14rem 0.14rem 0 0;
        padding: 0.2rem 0.19rem;
        font-size: 0.22rem;
        background: url(~@/assets/images/live-tab.png) no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        li {
          border-radius: 0.1rem 0.2rem 0.25rem 0.25rem;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          width: 2.3rem;
          height: 0.66rem;
          background: #f6f6f6;
          color: #8a8989;
        }
        .active {
          background: #0358dd;
          color: #fff;
          border: 0.02rem solid #fff;
          box-sizing: content-box;
        }
      }
      .live-channel-hid {
        min-height: 7rem;
        ul {
          background: #ffffff;
          padding: 0.3rem;
          border-radius: 0 0 0.2rem 0.2rem;
          li {
            &:last-child {
              border: 0;
            }
            .live-top {
              display: flex;
              justify-content: space-between;
              padding: 0.13rem 0 0.24rem;
              align-items: center;
              .flex-1 {
                width: 0.8rem;
                img {
                  width: 0.6rem;
                  margin-bottom: -0.15rem;
                }
              }
              .flex-2 {
                width: 4rem;
                .time {
                  display: inline-block;
                  font-size: 0.24rem;
                  color: #858585;
                  padding-right: 0.15rem;
                  /* border-right: 0.01rem solid #ccc; */
                }
                .type {
                  font-size: 0.24rem;
                  color: #999999;
                  padding-left: 0.15rem;
                }
                h3 {
                  font-size: 0.24rem;
                  color: #332d5c;
                  font-weight: 900;
                }
              }
              .flex-3 {
                display: inline-block;
                width: 1.17rem;
                height: 0.3rem;
                line-height: 0.3rem;
                font-size: 0.18rem;
                color: #fff;
                border-radius: 5rem;
                font-weight: 400;
                vertical-align: middle;
                text-align: center;
                margin-top: 0.3rem;
                &.btn-1 {
                  background-color: #3f5caa;
                }
                &.btn-2 {
                  background-color: #f15d57;
                }
                &.btn-3 {
                  background-color: #aeb6bf;
                }
                .status-point1 {
                  display: inline-block;
                  width: 0.1rem;
                  height: 0.1rem;
                  background-color: #fff;
                  border-radius: 50%;
                  margin: 0.1rem 0.05rem 0rem 0rem;
                  line-height: 0.4rem;
                  vertical-align: top;
                }
                .status-point2 {
                  background-color: #fff;
                  display: inline-block;
                  width: 0.1rem;
                  height: 0.1rem;
                  border-radius: 50%;
                  margin-right: 0.05rem;
                  margin: 0.15rem 0.05rem 0rem 0rem;
                  line-height: 0.4rem;
                  vertical-align: top;
                }
              }
              .red {
                color: red;
              }
            }

            .live-item {
              padding: 0.3rem 0.15rem;
              // border-bottom: 1px solid#8DA6AE;
              background-color: #e2f6fd;
              border-radius: 0.2rem;
              margin-top: 0.2rem;
              dl {
                display: flex;
                justify-content: space-between;
                dt {
                  width: 1.24rem;
                  margin-right: 0.2rem;
                  position: relative;
                  display: flex;
                  align-items: center;
                  height: 1.6rem;

                  img {
                    width: 1.24rem;
                    height: 1.24rem;
                    background: #fff;
                    border-radius: 0.85rem;
                  }
                  span {
                    width: 1.24rem;
                    height: 0.38rem;
                    position: absolute;
                    bottom: 0;
                    margin: auto;
                    color: #fff;
                    text-align: center;
                    border-radius: 0.2rem 0.2rem 0.2rem 0;
                    font-size: 0.22rem;
                    line-height: 0.38rem;
                    &.btn-1 {
                      background: #2d66e8;
                    }
                    &.btn-2 {
                      background: #ff6368;
                    }
                    &.btn-3 {
                      background: #aeb6bf;
                    }
                  }
                }
                dd {
                  width: 4.3rem;
                  // float: left;
                  h5 {
                    // height: 0.3rem;
                    border-left: 0.05rem solid #0ae4d3;
                    font-size: 0.3rem;
                    color: #101010;
                    font-weight: 700;
                    line-height: 0.3rem;
                    padding-left: 0.15rem;
                  }
                  b {
                    display: inline-block;
                    font-size: 0.22rem;
                    font-weight: 600;
                    padding-left: 0.15rem;
                    color: #333333;
                  }
                  p {
                    padding: 0rem 0.15rem;
                    border-radius: 0.08rem;
                    font-size: 0.2rem;
                    line-height: 0.28rem;
                    color: #333333;
                    margin-top: 0.1rem;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.tc-bg1 {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
  .tc {
    width: 5.8rem;
    height: 3.1rem;
    background-color: #fff;
    border-radius: 0.2rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    p {
      font-size: 0.24rem;
      text-align: center;
    }
    .close {
      position: absolute;
      right: 0;
      top: 0;
      width: 0.2rem;
      height: 0.2rem;
      padding: 0.2rem;
      box-sizing: content-box;
    }
    .warning {
      width: 0.84rem;
      height: 0.7rem;
      display: block;
      margin: 0.2rem auto 0.2rem;
    }
    .btn {
      display: flex;
      justify-content: space-around;
      padding: 0.3rem 1.26rem 0;
      button {
        padding: 0.08rem 0.3rem;
        border: 0;
        font-size: 0.24rem;
        border-radius: 5rem;
        outline: none;
        background-color: #3159d9;
        color: #fff;
      }
    }
  }
}
</style>